module.exports = new __parcel__URL__("document.20f528d4.svg").toString();